import { renderAuthoredNarrativeBundle } from './authoredNarrativeRender';

const CHART_ID = 'public_assistance';

export function buildPublicAssistanceAuthoredBundle(params: {
  locationName: string;
  latestYear: number | null;
  assistanceMetricLabel: string;
  assistanceUniverseLabel: string;
  assistanceRate: number | null;
  countSentence: string;
  trendSentence: string;
  comparisonSentence: string;
}) {
  const tokens = {
    locationName: params.locationName,
    latestYear: params.latestYear != null ? String(params.latestYear) : '—',
    assistanceMetricLabel: params.assistanceMetricLabel,
    assistanceUniverseLabel: params.assistanceUniverseLabel,
    assistanceRate: params.assistanceRate != null ? params.assistanceRate.toFixed(1) : '—',
    countSentence: params.countSentence,
    trendSentence: params.trendSentence,
    comparisonSentence: params.comparisonSentence,
  };
  const bundle = renderAuthoredNarrativeBundle(CHART_ID, 'default', tokens);
  bundle.methodology = undefined;
  return bundle;
}
